import {Badge} from 'antd'
import {article_getMentionedArticlesByRef_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import classNames from 'classnames'
import getLinkToDetail from 'helpers/getLinkToDetail'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import {BiHash} from 'react-icons/bi'
import {
    BsChat,
    BsClipboard,
    BsDiamondFill,
    BsGear,
    BsGearFill,
    BsInfoCircle,
    BsInfoCircleFill,
    BsLink,
} from 'react-icons/bs'
import {IoNewspaper, IoNewspaperOutline} from 'react-icons/io5'
import {Link} from 'react-router-dom'
import {CDActionTypes} from 'views/Document'
import EntityList from 'views/AppLocals/EntityList'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {AdvancedActionGroups} from 'views/NewTemplate/components/AdvancedActionGroups'
import {renderIf} from 'views/Shared'
import {CodiReportButton} from '../../../ErrorReport/components/ReportButton'
import {paths} from '../../../MainPage/contains'
import CodiDocumentContext from '../../CodiDocumentContext'
import {renderMentionsArticle} from '../../functions/renderMentionsArticle'
import {CodiDocumentActions} from './CodiDocumentActions'
import CodiDocumentComments from './CodiDocumentComments'
import CodiDocumentKeyWord from './CodiDocumentKeyWord'
import {CodiDocumentTree} from './CodiDocumentMenu'
import CodiDocumentSource, {CodiDocumentSourceRelated} from './CodiDocumentSource'
import CodiDocumentTimeLine from './CodiDocumentTimeLine'
import {CodiSiderHeading, CodiSubHeader} from './CodiSiderHeading'
import {LawSvg} from '../../../../components/Svgs/LawSvg'
import {PiBooks} from "react-icons/pi";
import {VscListTree} from "react-icons/vsc";
import {isSystemAdmin} from "../../../../helpers/authUtils";
import {formatDate} from "../../../../helpers/datetimeHelpers";

export const LinkedArticles = ({
                                   id,
                                   type,
                                   style,
                                   style2,
                                   className,
                                   className2,
                                   header = null,
                                   hideOnEmpty = false,
                               }) => {
    const t = useTranslate()

    const apiInfo = article_getMentionedArticlesByRef_Api

    const refreshKey = useMemo(
        () => [apiInfo?.path?.replace(':id', id)?.replace(':type', type)].join('/'),
        [id, type]
    )

    if (!(id && type)) return null;

    return (
        <EntityList
            apiInfo={apiInfo}
            refreshKey={refreshKey}
            RenderEntity={React.Fragment}
            renderItem={renderMentionsArticle}
            renderWrap={(child, __, count) =>
                renderIf(
                    !hideOnEmpty || count > 0,
                    <div
                        style={style}
                        className={classNames('flex flex-col', className)}>
                        {header}
                        <CodiSubHeader
                            title={t('list of article')}
                            className="mb-2"
                        />
                        <div
                            style={style2}
                            className={classNames('flex flex-col gap-2', className2)}>
                            {child}
                        </div>
                    </div>
                )
            }
            query={bindQueryParams([{id}, {type}])}
        />
    )
}

const CategoriesContent = ({className, children, items = []}) => {
    const getUrl = (category) => {
        const {id, language, alt_idname} = category
        const url = paths.categoryPath
            .replace(':category', id)

        return url
    }
    return (
        <div className={className}>
            {children}
            {items.map((item) => (
                <Link
                    key={item.id}
                    to={getUrl(item)}
                    className="flex items-center gap-1 font-medium text-primary text-xs italic">
                    <BsDiamondFill size={5}/>
                    {item.name}
                </Link>
            ))}
        </div>
    )
}

const DescriptionItem = ({label, className, children}) => (
    <Translate>
        {(t) => (
            <div className={classNames('flex text-xs', className)}>
                <span className="text-color-500 italic">{`${t(label)} : `}</span>
                {children}
            </div>
        )}
    </Translate>
)

const OriginalDocument = ({document}) => {
    const t = useTranslate()
    return (
        <div className="flex flex-col">
            <CodiSubHeader title="original document"/>
            <div className="flex flex-col gap-1 mt-2">
                <Link
                    target="_blank"
                    className="text-primary font-bold no-underline"
                    to={getLinkToDetail(document)}>
                    {_.get(document, 'title')}
                </Link>
                <div className="ml-1 space-y-1">
                    <div className="text-xs text-color-300 italic">
                        {_.get(document, 'description')}
                    </div>

                    {[
                        {label: 'issued org name', name: 'issued_place.title'},
                        {
                            label: 'published date',
                            name: 'published_date',
                            transform: (value) =>
                                value ? formatDate(value, 'DD/MM/YYYY') : t('undefined'),
                        },
                        {
                            label: 'eff date',
                            name: 'effected_date',
                            transform: (value) =>
                                value ? formatDate(value, 'DD/MM/YYYY') : t('undefined'),
                        },
                        {label: 'document no', name: 'document_no'},
                    ].map(({label, name, transform = (value) => value}, index) => {
                        const value = _.get(document, name)
                        return (
                            <DescriptionItem
                                key={index}
                                label={label}
                                className="items-center gap-1">
                <span className="font-bold text-color-100">
                  {transform(value)}
                </span>
                            </DescriptionItem>
                        )
                    })}

                    <DescriptionItem
                        label="categories"
                        className="items-start gap-2">
                        <CategoriesContent
                            items={document?.categories ?? []}
                            className="flex flex-wrap flex-1 gap-x-2 gap-y-1"
                        />
                    </DescriptionItem>
                </div>
            </div>
        </div>
    )
}

export const CodiInformation = ({document, showReport = true}) => {
    const {item} = useContext(CodiDocumentContext)

    const categories = useMemo(
        () => {

            return !_.isEmpty(item?.categories) && (
                <div className="flex flex-col">
                    <CodiSubHeader
                        title="categories"
                        className="mb-2"
                    />
                    <CategoriesContent
                        items={_.get(item, 'categories', [])}
                        className="flex flex-wrap gap-x-3 gap-y-2"
                    />
                </div>
            )
        },
        [item.categories]
    )

    return (
        <div className="flex flex-col">
            <div className="flex flex-col p-2 space-y-3">
                <CodiSiderHeading
                    title="document info"
                    icon={
                        <BsInfoCircleFill
                            size={20}
                            className="text-primary"
                        />
                    }
                />
                <OriginalDocument document={document}/>
                {categories}
                {showReport && (
                    <div className="space-y-2">
                        <CodiSubHeader title="error report"/>
                        <AdvancedActionGroups.SimpleActionWrapper
                            title="report to admin"
                            description="report to admin description">
                            <CodiReportButton
                                showHeader={false}
                                id={getId(item)}
                            />
                        </AdvancedActionGroups.SimpleActionWrapper>
                    </div>
                )}
            </div>
            <div className="h-10"/>
        </div>
    )
}

export const codiSiderMenu = {
    indexes: {
        key: 'indexes',
        label: 'table of contents',
        icon: <VscListTree size={23}/>,
        modal_action: CDActionTypes.SHOW_INDEXES_MODAL,
        Component: (props) => (
            <CodiDocumentContext.Consumer>
                {({item}) => (
                    <CodiDocumentTree
                        {...props}
                        item={item}
                        header={
                            <CodiSiderHeading
                                title="table of contents"
                                icon={
                                    <VscListTree
                                        size={20}
                                        className="text-primary"
                                    />
                                }
                            />
                        }
                        className="p-2"
                    />
                )}
            </CodiDocumentContext.Consumer>
        ),
    },
    dividerItem: {
        type: 'divider',
    },
    details: {
        key: 'details',
        label: 'content details',
        icon: <BsClipboard size={21}/>,
        modal_action: CDActionTypes.SHOW_DETAIL_MODAL,
        Component: () => <CodiDocumentTimeLine className="p-2"/>,
    },
    comments: {
        key: 'comments',
        label: 'comments',
        icon: <BsChat size={21}/>,
        modal_action: CDActionTypes.SHOW_COMMENT_MODAL,
        Component: () => <CodiDocumentComments className="p-2"/>,
    },
    settings: {
        key: 'settings',
        label: 'management',
        icon: <BsGear size={21}/>,
        isInvisible: (login) => !isSystemAdmin(login),
        modal_action: CDActionTypes.SHOW_ADMIN_MODAL,
        Component: (props) => (
            <CodiDocumentActions
                {...props}
                header={
                    <CodiSiderHeading
                        title="management"
                        icon={
                            <BsGearFill
                                size={20}
                                style={{marginTop: '0.15rem'}}
                                className="text-primary"
                            />
                        }
                    />
                }
                className="p-2"
            />
        ),
    },
    linkedCodiDocuments: {
        key: 'linked-codi-documents',
        label: 'codi link documents',
        icon: (
            <Badge count={<BsLink style={{color: '#094866'}}/>}>
                <PiBooks
                    width={21}
                    height={21}
                    size={21}
                />
            </Badge>
        ),
        modal_action: CDActionTypes.SHOW_LINKED_CODI_DOCUMENTS_MODAL,
        Component: (props) => (
            <CodiDocumentContext.Consumer>
                {({item, document}) => (
                    <CodiDocumentSource
                        {...props}
                        codi_id={getId(item)}
                        document_id={getId(document)}
                        header={
                            <React.Fragment>
                                <CodiSiderHeading
                                    title="codi link documents"
                                    icon={
                                        <PiBooks
                                            size={20}
                                            width={20}
                                            height={20}
                                            style={{marginTop: '0.15rem'}}
                                            className="text-primary"
                                        />
                                    }
                                />
                            </React.Fragment>
                        }
                        className="p-2"
                    />
                )}
            </CodiDocumentContext.Consumer>
        ),
    },
    linkedArticles: {
        key: 'linked-articles',
        label: 'linked articles',
        icon: (
            <Badge count={<BsLink style={{color: '#094866'}}/>}>
                <IoNewspaperOutline size={21}/>
            </Badge>
        ),
        modal_action: CDActionTypes.SHOW_LINKED_ARTICLES_MODAL,
        Component: (props) => (
            <CodiDocumentContext.Consumer>
                {({item}) => (
                    <LinkedArticles
                        {...props}
                        id={getId(item)}
                        type={getType(item)}
                        header={
                            <React.Fragment>
                                <CodiSiderHeading
                                    title="linked articles"
                                    icon={
                                        <IoNewspaper
                                            size={20}
                                            style={{marginTop: '0.15rem'}}
                                            className="text-primary"
                                        />
                                    }
                                />
                            </React.Fragment>
                        }
                        className="p-2"
                    />
                )}
            </CodiDocumentContext.Consumer>
        ),
    },
    linkedDocuments: {
        key: 'linked-documents',
        label: 'associated link documents',
        icon: (
            <Badge count={<BsLink style={{color: '#094866'}}/>}>
                <LawSvg
                    size={21}
                    width={21}
                    height={21}
                />
            </Badge>
        ),
        isInvisible: (login) => !isSystemAdmin(login),
        modal_action: CDActionTypes.SHOW_LINKED_DOCUMENTS_MODAL,
        Component: (props) => (
            <CodiDocumentContext.Consumer>
                {({item, document}) => (
                    <CodiDocumentSourceRelated
                        {...props}
                        codi_id={getId(item)}
                        document_id={getId(document)}
                        header={
                            <React.Fragment>
                                <CodiSiderHeading
                                    title="associated link documents"
                                    icon={
                                        <LawSvg
                                            size={20}
                                            width={20}
                                            height={20}
                                            className="text-primary"
                                        />
                                    }
                                />
                            </React.Fragment>
                        }
                        className="p-2"
                    />
                )}
            </CodiDocumentContext.Consumer>
        ),
    },
    info: {
        key: 'info',
        label: 'document info',
        icon: (
            <BsInfoCircle
                size={21}
                style={{marginTop: '0.15rem'}}
            />
        ),
        modal_action: CDActionTypes.SHOW_INFO_MODAL,
        Component: () => (
            <Translate>
                {(t) => (
                    <CodiDocumentContext.Consumer>
                        {({document}) => <CodiInformation document={document}/>}
                    </CodiDocumentContext.Consumer>
                )}
            </Translate>
        ),
    },
    keywords: {
        key: 'keywords',
        label: 'keywords',
        modal_action: CDActionTypes.SHOW_KEYWORD_MODAL,
        icon: <BiHash size={23}/>,
        Component: () => <CodiDocumentKeyWord className="p-2"/>,
    },
}
